import { render } from "./clients.html?vue&type=template&id=4abd070e&scoped=true&ts=true&external"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import "./Clients.vue?vue&type=style&index=0&id=4abd070e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abd070e"]])

export default __exports__